import { shouldFireMedPixel } from "src/utils/userSegment/features";
import { registerHandler, Sha256Email } from "../handler";
import { MedProductType } from "src/utils/constants";
import { generateEventId } from "../utils";
import { allowCategories, LibCategories } from "src/utils/consent";

declare const snaptr: any;

let snapInitEmail: string;

const NOOM_MED_SNAPCHAT_PIXEL = "69c5a9b1-9efd-4f96-808f-7d7d85efdb47";
const NOOM_WEIGHT_SNAPCHAT_PIXEL = "e030eb4f-d3fd-4c13-9338-9c0a3b6847ad";

function getSnapchatPixelId() {
  if (shouldFireMedPixel()) {
    return NOOM_MED_SNAPCHAT_PIXEL;
  }
  return NOOM_WEIGHT_SNAPCHAT_PIXEL;
}

function initSnap(email: Sha256Email) {
  if (
    allowCategories([LibCategories.targetingCookies]) &&
    email &&
    snapInitEmail !== email
  ) {
    snaptr("init", getSnapchatPixelId(), {
      user_email: email,
    });
    snaptr("track", "PAGE_VIEW");
    snapInitEmail = email;
  }
}

export default function registerHandlers() {
  registerHandler("purchase", ({ emailHashes, order, plan }) => {
    initSnap(emailHashes.sha256);

    snaptr("track", "SIGN_UP", {
      user_hashed_email: emailHashes.sha256,
      currency: plan.currency || "USD",
      transaction_id: order.subscriptionId,
      price: order.eltv_13_months,
    });
  });

  registerHandler(
    "purchaseIntent",
    ({ emailHashes, medProductType, plan, estimatedValue, userId }) => {
      if (medProductType !== MedProductType.HRT) {
        initSnap(emailHashes.sha256);
        snaptr("track", "SIGN_UP", {
          user_hashed_email: emailHashes.sha256,
          currency: plan.currency || "USD",
          transaction_id: generateEventId(userId),
          price: estimatedValue,
        });
      }
    }
  );
}
